var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imageObject)?_c('v-img',{staticClass:"action-image",attrs:{"contain":"","width":"100%","height":"100%","srcset":_vm.srcset,"sizes":_vm.sizes,"src":_vm.imageObject.url,"alt":_vm.imageObject.alternativeText}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }